import React, { useState, useEffect } from "react";
import "./gototop.scss";
import { IoArrowUpCircleOutline } from "react-icons/io5";

const GoTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="top-to-btm">
      {showTopBtn && (
        <button className="icon-position icon-style" onClick={goToTop}>
          <IoArrowUpCircleOutline />
        </button>
      )}
    </div>
  );
};
export default GoTop;
